module.exports = __webpack_public_path__ + "static/cf-reg-ext-29bcdb31628a32e1880237512cc5bc9c.eot";